<template>
    <v-window-item value="preparations">
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <div class="d-flex justify-space-between align-center mb-4">
                        <h2 class="text-h6">Asset Preparations</h2>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" class="pa-1">
                    <v-data-table
                        :headers="compnentsHeaders"
                        :items="preparationsData"
                        :loading="loading"
                        :hover="true"
                        density="compact"
                        elevation="0"
                        class="border-sm rounded-md"
                    >
                    
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-window-item>
</template>

<script>

export default {
    props: {
        preparationsData: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
        }
    },
    components: {},
    data: () => ({
        dialog: false,
        loading: false,
        compnentsHeaders: [
            { title: "Preparation Date", key: "asset_preparation.preparation_date", align: "center", sortable: false },
            { title: "Preparation Cost", key: "preparation_cost", align: "center", sortable: false },
        ],
    }),
    computed: {},
    watch: {},
    created() {},
    methods: {},
    setup(props, {emit}){},
    mounted() {
        
    },
}
</script>